export default "__VITE_ASSET__BAKOeaDp__"